import { BlockViewExtension } from '@blocksuite/affine/block-std';
import type { ExtensionType } from '@blocksuite/affine/store';
import { literal } from 'lit/static-html.js';

export const AnalyzeResultBlockSpec: ExtensionType[] = [
  BlockViewExtension(
    'affine:analyze-result',
    () => literal`affine-analyze-result`
  ),
];
